import React, { useEffect, useRef } from "react";
import HeroVideo from "../../Assets/Video/Hero_video.mp4";

const SimpleBanner = ({
  title = "",
  subheading = "",
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      // Slow down the video
      videoRef.current.playbackRate = 0.75;
    }
  }, []);

  return (
    <div className="relative w-full h-[250px] sm:h-[250px] md:h-[250px] lg:h-[400px] overflow-hidden">
      {/* Background Video */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={HeroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/45"></div>

      {/* Content */}
      <div className="absolute inset-0 top-16 md:top-24 z-10 flex items-center justify-center px-4 text-center">
        <div className="max-w-[1200px]">
          <h1 className="text-lg md:text-4xl font-bold text-white font-saira">
            {title}
          </h1>

          {subheading && (
            <p className="mt-3 text-sm sm:text-base md:text-lg text-white/90 font-saira">
              {subheading}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimpleBanner;